// @flow

import * as languageData from '../Components/Language.js';

export default function getLanguage() {
  // Check browsers for user locale
  const language = (navigator.languages && navigator.languages[0]) ||
                    navigator.language;

  // Split locales with a region code
  const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
  const messages = languageData[languageWithoutRegionCode] || languageData[language] || languageData.en;
  return messages;
}



// WEBPACK FOOTER //
// ./src/js/libs/Languages.js